/* Highlights the chosen rating in the write-a-review star picker. */
(function () {
  function paint(group) {
    var checked = group.querySelector('input:checked');
    var val = checked ? parseInt(checked.value, 10) : 0;
    [].slice.call(group.querySelectorAll('label')).forEach(function (l) {
      l.classList.toggle('on', parseInt(l.getAttribute('data-i'), 10) <= val);
    });
  }
  function hover(group, n) {
    [].slice.call(group.querySelectorAll('label')).forEach(function (l) {
      l.classList.toggle('on', parseInt(l.getAttribute('data-i'), 10) <= n);
    });
  }
  document.addEventListener('change', function (e) {
    var g = e.target.closest ? e.target.closest('[data-stars]') : null;
    if (g) paint(g);
  });
  document.addEventListener('mouseover', function (e) {
    var l = e.target.closest ? e.target.closest('[data-stars] label') : null;
    if (l) hover(l.closest('[data-stars]'), parseInt(l.getAttribute('data-i'), 10));
  });
  document.addEventListener('mouseout', function (e) {
    var g = e.target.closest ? e.target.closest('[data-stars]') : null;
    if (g) paint(g);
  });
  function init() { [].slice.call(document.querySelectorAll('[data-stars]')).forEach(paint); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
